import { AGENCY_POLICY_LIST_PRODUCT_CODES, AGENCY_POLICY_LIST_STATUS } from '../../../constants'

const host = process.env.REACT_APP_URL
const BASE_PATH = 'api/v1/agency/'

const agencyPolicyDetail = () => {
  return `${host}${BASE_PATH}policy-details/?er=1`
}

const validateAgencyClaimUrl = () => {
  return `${host}${BASE_PATH}validate-claim/`
}

const postAgencyClaim = () => {
  return `${host}${BASE_PATH}create-claim/`
}

const agencyBenefitsURL = payload => {
  return `${host}${BASE_PATH}benefit-list/?package_code=${payload.package}&product_key=${payload.product}&insurance_provider=${payload.insurance_provider}`
}

const agencyPolicyListURL = (payload = {}) => {
  const { query = {} } = payload
  const { coverageStatus, page, pageSize, status = AGENCY_POLICY_LIST_STATUS, productCode = AGENCY_POLICY_LIST_PRODUCT_CODES } = query
  const productCodes = Array.isArray(productCode) ? productCode : [productCode]

  const params = new URLSearchParams()
  params.append('status', status)
  productCodes.forEach(code => params.append('product_code', code))
  if (coverageStatus) params.append('coverage_status', coverageStatus)
  if (page) params.append('page', page)
  if (pageSize) params.append('page_size', pageSize)

  return `${host}${BASE_PATH}policy-list?${params.toString()}`
}
const agencyClaimListURL = payload => {
  return `${host}${BASE_PATH}claim-list`
}

export default {
  agencyPolicyDetail,
  validateAgencyClaimUrl,
  postAgencyClaim,
  agencyBenefitsURL,
  agencyPolicyListURL,
  agencyClaimListURL
}
